import React from "react";

function FormGroup({ children }) {
  return <div className="tcf-form-group">{children}</div>;
}

export default FormGroup;
